// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// Custom Imports
import MultiSlider from './class/MultiSlider';
import Slider from './class/Slider';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

document.addEventListener('DOMContentLoaded', function(){

  /**
   *  Find and initialize any sliders or multisliders found on any pages. 
   */
  let multiCategorySliders = document.querySelectorAll('.slideshow-container.multi-category');
  multiCategorySliders.forEach(function(slideshow){
    new MultiSlider(slideshow);
  });

  let singleCategorySliders = document.querySelectorAll('.slideshow-container.single-category .slideshow-images');
  singleCategorySliders.forEach(function(slideshow){
    new Slider(slideshow);
  });

  let formLabels = document.querySelectorAll('.gform_wrapper .gfield_label');
  formLabels.forEach(function(label){
    label.innerHTML = label.innerHTML.replace(/([^<])(\/.*)$/g, '$1<span class="label-small">$2</span>');
  });

  /**
   * Cookie Banner
   */
  cookie_banner();
});

function cookie_banner(){
  let banner = document.querySelectorAll('.cookie-banner');
  let closeDialog = document.querySelectorAll('.close-dialog');

  if(!banner){
    return;
  }

  banner.forEach(function(element){
    if (localStorage.getItem('cookieSeen') != 'shown') {
      element.className += ' show';
    }
  });
  

  if(!closeDialog){
    return;
  }

  closeDialog.forEach(function(element){
    element.addEventListener('click', function(){
      localStorage.setItem('cookieSeen', 'shown')
      
      banner.forEach(function(elm){
        elm.className = elm.className.replace(/ show/, '');
      });
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/main.js